import { Alert, Flex } from '@/_components';
import type { FC } from 'react';
import type { QuestionMarkedCompletedProps } from './QuestionMarkedCompleted.types';

export const QuestionMarkedCompleted: FC<QuestionMarkedCompletedProps> = () => {
  return (
    <Flex isInline={true}>
      <Alert type="info" icon="info">
        This question was marked as completed.
      </Alert>
    </Flex>
  );
};
